/**
 * Zip Code Validation Helper
 *
 * Accepts every format the backend's `zipCodeIntl` custom Obey type persists,
 * so a value saved on an order can never fail client-side zip validation when
 * the order is loaded back into the form.
 *
 * US formats: 12345, 123456789, 12345-6789, 12345 6789 (the ZIP+4 separator
 * is any mix of dashes/spaces, including none)
 * CA formats: A1A 1A1, A1A1A1 (any number of spaces; case-insensitive —
 * deliberately looser than the backend's uppercase-only rule)
 */

// US: 5 digits, optionally followed by [-\s]* separator and 4 digits
// CA: Letter-Digit-Letter space* Digit-Letter-Digit
const ZIP_REGEX = /^(\d{5}([-\s]*\d{4})?|[A-Za-z]\d[A-Za-z]\s*\d[A-Za-z]\d)$/

/**
 * Validates a zip/postal code against US and Canadian formats.
 * Returns true if valid or empty (empty is handled by required checks elsewhere).
 *
 * @param {string} zip - Zip code to validate
 * @returns {boolean} Whether zip is valid
 */
export const isValidZipCode = (zip) => {
  if (!zip || zip.length === 0) return true // Empty handled by required checks
  return ZIP_REGEX.test(zip.trim())
}
